function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, forwardRef, useImperativeHandle } from 'react';
var modes = {
  'success': 'fa-check',
  'error': 'fa-hexagon-exclamation',
  'notice': 'fa-flag'
};
function generateId() {
  return String(Math.random()).substring(2, 12);
}
var FlashMessage = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    messages = _useState2[0],
    setMessages = _useState2[1];
  useImperativeHandle(ref, function () {
    return {
      show: show
    };
  });
  function show(flashMessage) {
    var flashMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';
    var visibilityDuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3000;
    if (flashMessage) {
      var messageId = generateId();
      setMessages(function (prevState) {
        return [].concat(_toConsumableArray(prevState), [{
          id: messageId,
          title: flashMessage,
          mode: flashMode,
          visibilityDuration: visibilityDuration
        }]);
      });
      startTimeout(messageId, visibilityDuration);
    }
  }
  function startTimeout(messageId) {
    var visibilityDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
    setTimeout(function () {
      setMessages(function (prevState) {
        var updatedMessages = _toConsumableArray(prevState);
        var messageIndex = updatedMessages.findIndex(function (message) {
          return message.id === messageId;
        });
        if (messageIndex >= 0) {
          updatedMessages[messageIndex] = _objectSpread(_objectSpread({}, updatedMessages[messageIndex]), {}, {
            fadeOut: true
          });
        }
        return updatedMessages;
      });
      setTimeout(function () {
        setMessages(function (prevState) {
          return prevState.filter(function (message) {
            return message.id !== messageId;
          });
        });
      }, 1000);
    }, visibilityDuration);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, messages.map(function (message, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "flash-container ".concat(message.mode, " ").concat(message.fadeOut ? 'animated fadeOutRight' : 'animated fadeInRight'),
      style: {
        top: 40 * index
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-box items-center content-center"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa-light ".concat(modes[message.mode])
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        marginLeft: 20
      }
    }, message.title)));
  }));
});
export default FlashMessage;